export const fileUploadConst = {
  SHOWROOMMODE: 1,
  CAMPAIGNMANAGEMENT: 2,
};
